/**
 * Assorted libraries that must be on the global namespace.
 * We should try to not use this as much as possible.
 * @type {_|exports|module.exports}
 * @private
 *
 * Understand the expose-loader: https://github.com/webpack/expose-loader
 */

require('babel-polyfill');

// Bind polyfill
// PhantomJS doesn't support bind yet
Function.prototype.bind = Function.prototype.bind || function (that) {
  var fn = this;
  return function () {
    return fn.apply(that, arguments);
  };
};

window.Bloodhound = require('typeahead.js/dist/bloodhound');
window.Strftime = require('strftime');
window._ = require('lodash');
window.herment = require('lib/herment/herment');
window.typeahead = require('typeahead.js/dist/typeahead.jquery');



// WEBPACK FOOTER //
// ./app/javascript/packs/globals.js